<template>
  <div class="bg-secondary messageSMS">
    <!-- Header -->
    <b-navbar type="dark" variant="white" class="p-2 sticky" sticky>
      <span v-if="!loading" class="navbar-brand">
        <img v-if="companyLogo || appLogo" :src="logo" />
        <span> {{ clientName }}</span>
      </span>
    </b-navbar>
    <!-- Page content -->
    <div class="container container bg-secondary mt-4">
      <div v-if="!loading" class="row justify-content-center">
        <div class="col-lg-12 col-md-12 cols-12">
          <h2 class="text-center">Your account is verified</h2>

          <div class="row mb-3">
            <div class="w-100 text-center">
              <div class="message-content">Your message can now be sent as pushcast</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="row justify-content-center">
        <b-row>
          <div class="col-lg-12 text-center">
            <pulse-loader :color="'#3867d6'"></pulse-loader>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Media from '@dongido/vue-viaudio';
export default {
  name: 'RegisterSMS',
  components: {
    Media,
  },
  data() {
    return {
      companyName: '',
      companyLogo: null,
      channelName: '',
      appLogo: null,
      companyCopyright: '',
      packages: {
        links: [],
      },
      hasReadReceipt: false,
      hasFeedback: false,
      feedbackComment: '',
      feedbackYes: null,
      feedbackNo: null,
      message: {
        message: '',
      },
      title: null,
      file: null,
      messageDescription: null,
      companyInfo: null,
      readResponse: 0,
      iosAppUrl: false,
      androidAppUrl: false,
      messageID: null,
      userID: null,
      channelID: null,
      url: null,
      type: null,
      memberBenefitShow: false,
    };
  },
  computed: {
    logo: {
      get: function () {
        return this.appLogo || this.companyLogo;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    clientName: {
      get: function () {
        return this.channelName || this.companyName;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    loading() {
      return this.$store.state.messages.emailPushcastLoading;
    },
  },
  watch: {},
  mounted() {
    const messageID = this.$route.params.messageID;
    this.getEmailPushcastMessage(messageID);
  },
  methods: {
    getEmailPushcastMessage(messageID) {
      this.$store
        .dispatch('messages/GET_EMAIL_PUSHCAST', messageID)
        .then((resp) => {
          const data = resp.data.data;
          /*this.channelName = data.channelName || data.message.givenName
              this.appLogo = data.appLogo
              this.message = data.message
              this.companyInfo = data.companyInfo
              this.packages = data.packages

              if (this.message) {
                this.hasFeedback = this.message.enableFeedback === 1
                this.hasReadReceipt = this.message.isReadRequired === 1

                this.messageID = this.message._id
                this.userID = this.message.userid
                this.feedbackYes = this.message.feedback === 1 ? '1' : null
                this.feedbackNo = this.message.feedback === 0 ? '0' : null
                this.feedbackComment = this.message.feedbackComment
                this.readResponse =  this.message.readResponse
                this.url = this.message.url
                this.type = this.message.type
                this.title = this.message.title
                this.messageDescription = this.message.push_message
                this.file = this.message.html_file
              }*/
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
<style lang="scss">
.messageSMS {
  min-height: 736px;
  height: 812px;
}
span.navbar-brand {
  span {
    color: #000;
  }
  img {
    height: 60px;
  }
}
.message-content {
  h2 {
    padding-left: 15px;
    padding-right: 15px;
  }
  a {
    color: #5867dd;
  }
  .image {
    img {
      width: 100% !important;
    }
  }
}
.player-wrapper {
  margin: 0 auto;
}
</style>
